
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class ApprovalInItemsSelectGrid extends _Ext.GridBase<ApprovalInItemsRow,any> {
        protected getColumnsKey() { return 'Purchase.PurchaseItemsSelect'; }
        protected getDialogType() { return <any>ApprovalInItemsDialog; }
        protected getIdProperty() { return ApprovalInItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ApprovalInItemsRow.localTextPrefix; }
        //protected getInsertPermission() { return ApprovalInItemsRow.insertPermission; }
        //protected getUpdatePermission() { return ApprovalInItemsRow.updatePermission; }
        //protected getDeletePermission() { return ApprovalInItemsRow.deletePermission; }
        protected getService() { return PurchaseApprovalItemsService.baseUrl;}
        //protected useViewMode() { return true; } 
 
        constructor(container: JQuery, options) {
            super(container, options);            
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            return this;
        }

        private autoSize;
 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): ApprovalInItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}